import { render, staticRenderFns } from "./SplitTransloadDetails.vue?vue&type=template&id=25b80fd3"
import script from "./SplitTransloadDetails.vue?vue&type=script&lang=js"
export * from "./SplitTransloadDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports